export enum PaymentMethod {
  Card = 'card',
  BankTransfer = 'bank',
}

export const enum PaymentMethodEnum {
  CARD,
  TRANSFER,
}
